import { useTranslation } from 'next-i18next';
import * as React from 'react';
import ReactToPrint from 'react-to-print';

import { Button, Checkbox } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';

import Close from '~/images/shared/Close.svg';
import PrintIcon from '~/images/shared/print.svg';

interface IPrintToolBar {
  rowsLength: number;
  onClearTableSelection: () => void;
  qrcodeRef: React.MutableRefObject<null>;
  isPrintDisabled?: boolean;
  onePerPage?: boolean;
  setOnePerPage?: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function PrintToolBar(props: IPrintToolBar) {
  const {
    rowsLength,
    onClearTableSelection,
    isPrintDisabled,
    qrcodeRef,
    onePerPage,
    setOnePerPage,
  } = props;
  const { t } = useTranslation('common');

  return (
    <div className='mt-24 flex w-full items-center justify-start gap-20 rounded-2xl bg-neutralVariant-90 p-8 px-16'>
      <BaseIcon svgClasses='cursor-pointer text-primary-default' size='xxs'>
        <Close onClick={onClearTableSelection} />
      </BaseIcon>
      <div style={{ fontWeight: 600 }}>
        {rowsLength} {t('selected')}
      </div>
      <div className='ml-auto flex'>
        {!!setOnePerPage && (
          <Checkbox
            label={t('one-per-page')}
            id='one-per-page'
            checked={onePerPage}
            onClick={() => setOnePerPage((v) => !v)}
            disabled={isPrintDisabled}
          />
        )}
        <ReactToPrint
          removeAfterPrint
          content={() => qrcodeRef.current}
          trigger={() => (
            <Button variant='text' className=' !p-0' disabled={isPrintDisabled}>
              <div className='flex items-center justify-center gap-2 text-primary-default'>
                <BaseIcon size='xs'>
                  <PrintIcon />
                </BaseIcon>
                {t('print')}
              </div>
            </Button>
          )}
        />
      </div>
    </div>
  );
}
